<template>
	<div>
        <v-flex xs7 ml-5 mt-4>
            <v-layout wrap>
                <v-flex xs3 mr-3>
                    <v-text-field
                        background-color="white"
                        box
                        class="body-1"
                        hide-details
                        type="number"
                        label="Cantidad de Empleados"
                        required
                        v-model="employeeCount"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>
		</v-flex>
	</div>
</template>
<script>

function data() {
    return {
        employeeCount: 0,
    };
}

function created() {
    this.employeeCount = this.data.settings && this.data.settings.company
        ? this.data.settings.company.employeeCount : 0;
}

export default {
    name: 'configuration-products',
    data,
    created,
    props: {
        data: {
            type: Object,
        },
    },
    watch: {
        employeeCount(newVal) {
            this.$emit('update:employeeCount', newVal, 'employeeCount');
        }
    },
};

</script>


// WEBPACK FOOTER //
// src/components/configuration-general/configuration-employee.vue